var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFortune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1910_12009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1910_12009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.596 30.2199V38.162C10.596 39.0553 10.9509 39.912 11.5825 40.5437C12.2142 41.1754 13.071 41.5303 13.9643 41.5303C14.8576 41.5303 15.7144 41.1754 16.346 40.5437C16.9777 39.912 17.3326 39.0553 17.3326 38.162V30.2199C17.3326 29.3265 16.9777 28.4698 16.346 27.8381C15.7144 27.2064 14.8576 26.8516 13.9643 26.8516C13.071 26.8516 12.2142 27.2064 11.5825 27.8381C10.9509 28.4698 10.596 29.3265 10.596 30.2199ZM13.007 38.162V30.2199C13.0055 30.0923 13.0308 29.9658 13.0811 29.8486C13.1314 29.7313 13.2057 29.6259 13.2992 29.5391C13.3927 29.4523 13.5033 29.386 13.624 29.3445C13.7446 29.3029 13.8726 29.2871 13.9997 29.298C14.1219 29.2941 14.2435 29.3152 14.3571 29.3601C14.4708 29.4051 14.574 29.4728 14.6604 29.5592C14.7468 29.6456 14.8145 29.7488 14.8595 29.8625C14.9044 29.9761 14.9255 30.0977 14.9216 30.2199V38.162C14.9179 38.4053 14.8196 38.6377 14.6475 38.8098C14.4754 38.9818 14.2431 39.0801 13.9997 39.0838C13.874 39.0885 13.7486 39.0685 13.6306 39.0247C13.5126 38.9809 13.4045 38.9143 13.3123 38.8287C13.2201 38.7431 13.1456 38.6401 13.0933 38.5257C13.0409 38.4113 13.0116 38.2877 13.007 38.162ZM36.7624 27.0288H29.9548V29.4398H32.1531V41.2821H34.5641V29.4398H36.7624V27.0288ZM43.8535 27.0288V38.162C43.8535 38.4064 43.7564 38.6409 43.5835 38.8138C43.4106 38.9867 43.1761 39.0838 42.9317 39.0838C42.6872 39.0838 42.4527 38.9867 42.2798 38.8138C42.1069 38.6409 42.0098 38.4064 42.0098 38.162V27.0288H39.5279V38.162C39.5279 39.0647 39.8865 39.9304 40.5248 40.5688C41.1632 41.2071 42.0289 41.5657 42.9317 41.5657C43.8344 41.5657 44.7001 41.2071 45.3385 40.5688C45.9768 39.9304 46.3354 39.0647 46.3354 38.162V27.0288H43.8535ZM65.907 29.4398V27.0288H59.9504V41.2821H65.907V38.8711H62.3614V35.1837H64.6306V32.7727H62.3614V29.4398H65.907ZM27.6857 41.2821H25.1329L23.3601 34.5455C23.8024 34.4579 24.2003 34.2188 24.4851 33.8692C24.7699 33.5197 24.9237 33.0817 24.9201 32.6309V30.4326C24.923 30.3014 24.8993 30.171 24.8505 30.0493C24.8016 29.9275 24.7286 29.8169 24.6358 29.7241C24.543 29.6314 24.4324 29.5583 24.3107 29.5095C24.1889 29.4606 24.0585 29.4369 23.9274 29.4398H23.0055V41.2821H20.5945V27.0288H23.9274C24.8081 27.0209 25.6571 27.3577 26.2931 27.9671C26.929 28.5766 27.3015 29.4104 27.3311 30.2908V32.5599C27.3635 33.1488 27.2587 33.7372 27.0248 34.2786C26.791 34.8201 26.4347 35.2998 25.9838 35.6801L27.6857 41.2821ZM54.5612 27.0288V34.8291L52.0792 27.0288H49.5973V41.2821H52.0792V34.3327L54.3484 41.2821H57.0431V27.0288H54.5612ZM2.44116 27.2416V41.4948H4.99398V35.3964H7.33406V32.9854H4.99398V29.6526H8.68138V27.2416H2.44116Z",
    fill: "#F4F4F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1910_12009",
    x: -77.5588,
    y: -53.1484,
    width: 223.466,
    height: 174.714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0784314 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1910_12009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1910_12009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1910_12009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFortune);
export default __webpack_public_path__ + "static/media/icon-fortune.c0ca76ac4de3268f11141189d7f65d52.svg";
export { ForwardRef as ReactComponent };